import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing } from 'stylesheet';
import { Tag } from 'theme/icons';
var HighlightContainer = styled.div.withConfig({
  displayName: "HighlightWrapperstyle__HighlightContainer",
  componentId: "sc-1ipy6hk-0"
})(["padding:0 ", ";background-color:", ";"], getSpacing(2), colorUsage.embedBlockBackground);
var Highlight = styled.div.withConfig({
  displayName: "HighlightWrapperstyle__Highlight",
  componentId: "sc-1ipy6hk-1"
})(["padding:", ";background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";"], getSpacing(1), colorUsage.embedBlockForeground, function (props) {
  return props.isFirst ? borderRadius.medium : 'none';
}, function (props) {
  return props.isFirst ? borderRadius.medium : 'none';
}, function (props) {
  return props.isLast ? borderRadius.medium : 'none';
}, function (props) {
  return props.isLast ? borderRadius.medium : 'none';
});
var HighlightHeader = styled.div.withConfig({
  displayName: "HighlightWrapperstyle__HighlightHeader",
  componentId: "sc-1ipy6hk-2"
})(["padding:", " ", ";color:", ";font-size:", ";background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";cursor:default;user-select:none;"], getSpacing(1), getSpacing(2), colorUsage.embedBlockForeground, fontSize.small, colorUsage.embedBlockBackground, borderRadius.medium, borderRadius.medium);
var HighlightFooter = styled.div.withConfig({
  displayName: "HighlightWrapperstyle__HighlightFooter",
  componentId: "sc-1ipy6hk-3"
})(["padding-bottom:", ";background-color:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";"], getSpacing(2), colorUsage.embedBlockBackground, borderRadius.medium, borderRadius.medium);
var HighlightIcon = styled(Tag).withConfig({
  displayName: "HighlightWrapperstyle__HighlightIcon",
  componentId: "sc-1ipy6hk-4"
})(["width:13px;height:13px;margin-right:5px;vertical-align:middle;path{fill:", ";}"], colorUsage.embedBlockForeground);
export { Highlight, HighlightContainer, HighlightFooter, HighlightHeader, HighlightIcon };